import React from 'react';
import { colors } from '../../constants/theme';

const LoadingSpinner = ({ size = 'large', text = 'Carregando...' }) => {
  const sizeClasses = {
    small: 'h-8 w-8',
    medium: 'h-16 w-16',
    large: 'h-24 w-24'
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <div className={`${sizeClasses[size]} animate-spin`}>
        <div 
          className="h-full w-full rounded-full border-4 border-gray-300 border-t-4"
          style={{ borderTopColor: colors.primary }}
        ></div>
      </div>
      <p className="mt-4 text-lg font-medium text-gray-600">{text}</p>
    </div>
  );
};

export default LoadingSpinner;